<template>
  <div class="note-lab-device-config-page">
    <div class="global-header-wrap">
      <div class="user-header-left">
        <div class="left-part">
          <span>设备型号</span>
          <div class="listSearch">
            <el-input
              v-model="model"
              clearable
              @keyup.enter.native="search"
              @clear="clearSearch"
              placeholder="请输入设备型号"
            />
          </div>
        </div>
        <button class="global-button-style search-btn" @click="search">
          {{ $t("commonMsg.search") }}
        </button>
      </div>
      <div class="right-part">
        <button class="global-button-style" @click="handleAdd">
          <img src="@/assets/img/cmb_btn_add.png" />新增
        </button>
      </div>
    </div>

    <el-card class="app-table-container" :body-style="{ padding: '20px' }">
      <div slot="header" class="user-table-header">
        <p>总数：{{ total || 0 }}</p>
      </div>
      <div class="global-body-wrap" v-loading="loading">
        <el-table
          :data="tableData"
          border
          header-cell-style="background-color: #f7f7f7;font-weight: 500;"
        >
          <el-table-column
            prop="modelText"
            label="设备型号"
            align="center"
            show-overflow-tooltip
          />
          <el-table-column
            prop="enabled"
            label="启用状态"
            align="center"
            width="100"
          />
          <el-table-column
            prop="allowedRegionsText"
            label="支持地区"
            align="center"
            show-overflow-tooltip
          />
          <el-table-column
            prop="updatedAt"
            label="更新时间"
            align="center"
            width="180"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.updatedAt">{{
                scope.row.updatedAt | filterDate
              }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
            width="200"
            fixed="right"
          >
            <template slot-scope="scope">
              <span
                class="checkDetailsBtn"
                @click="handleViewOrEdit(scope.row)"
              >
                {{ scope.row.isDefault ? "查看" : $t("commonMsg.edit") }}
              </span>
              <span
                v-if="!scope.row.isDefault"
                class="delBtn"
                @click="confirmDelete(scope.row._id || scope.row.id)"
              >
                {{ $t("commonMsg.del") }}
              </span>
              <span
                v-if="!scope.row.isDefault"
                class="checkDetailsBtn"
                @click="handleShowOptLogs(scope.row._id || scope.row.id)"
              >
                操作详情
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <Pagination
        :pageSize="paramsList.pageSize"
        :total="total"
        @pageNum="pageNum"
        @pageSize="pageSizeChange"
        :pageSizes="true"
      />
    </el-card>

    <DeviceConfigDialog
      :visible.sync="dialogVisible"
      :editId="editId"
      :formData="dialogFormData"
      :regionOptions="regionOptions"
      @confirm="handleSubmit"
    />

    <OptRecordDialog ref="optRecordDialog" :fetchApi="fetchOptLogsApi" />
  </div>
</template>

<script>
import Pagination from "@/components/pagination";
import DeviceConfigDialog from "./components/deviceConfigDialog.vue";
import OptRecordDialog from "@/components/OptRecordDialog/index.vue";

export default {
  name: "NoteLabDeviceConfig",
  components: {
    Pagination,
    DeviceConfigDialog,
    OptRecordDialog,
  },
  data() {
    return {
      tableData: [],
      total: 0,
      model: "",
      paramsList: { page: 1, pageSize: 20 },
      loading: false,
      dialogVisible: false,
      editId: null,
      dialogFormData: {},
      regionOptions: [],
      regionMap: {},
    };
  },
  methods: {
    async getConfigList() {
      this.loading = true;
      try {
        const res = await this.$http.getNoteLabDeviceConfigs(this.paramsList);
        this.total = res.data.count || 0;
        this.tableData = (res.data.items || []).map((item) => ({
          ...item,
          modelText: item.isDefault
            ? "默认（未单独配置的型号）"
            : (item.models || []).join("、") || "-",
          enabledRaw: item.enabled !== false,
          enabled: item.enabled !== false ? "启用" : "停用",
          allowedRegionsText:
            (item.allowedRegions || [])
              .map((code) =>
                this.regionMap[code]
                  ? `${this.regionMap[code]}（${code}）`
                  : code
              )
              .join("、") || "-",
        }));
      } catch {
        // 错误提示已由 axios 拦截器统一处理
      } finally {
        this.loading = false;
      }
    },

    async getRegionOptions() {
      try {
        const res = await this.$http.getDeviceConfigRegions();
        this.regionOptions = res.data || [];
        this.regionMap = Object.fromEntries(
          this.regionOptions.map((item) => [item.code, item.name])
        );
      } catch {
        // 错误提示已由 axios 拦截器统一处理
      }
    },

    search() {
      this.paramsList.page = 1;
      if (this.model) {
        this.paramsList.model = this.model;
      } else {
        delete this.paramsList.model;
      }
      this.getConfigList();
    },

    clearSearch() {
      this.model = "";
      this.search();
    },

    handleAdd() {
      this.editId = null;
      this.dialogFormData = {};
      this.dialogVisible = true;
    },

    async handleViewOrEdit(row) {
      const id = row._id || row.id;
      if (!id) {
        this.$message({ type: "error", message: "无法获取记录ID" });
        return;
      }

      this.editId = id;
      if (row.isDefault) {
        this.dialogFormData = { ...row };
        this.dialogVisible = true;
      } else {
        try {
          const res = await this.$http.getNoteLabDeviceConfigDetail(id);
          this.dialogFormData = res.data || {};
          this.dialogVisible = true;
        } catch {
          // 错误提示已由 axios 拦截器统一处理
        }
      }
    },

    async confirmDelete(id) {
      if (!id) return;
      try {
        await this.$confirm(
          "确定要删除该设备配置吗？删除后该型号设备将不再受此配置约束。",
          "提示",
          { type: "warning" }
        );
      } catch {
        return;
      }
      try {
        await this.$http.deleteNoteLabDeviceConfig(id);
        this.$message({
          type: "success",
          message: this.$t("alertMsg.delSuccess"),
        });
        this.getConfigList();
      } catch {
        // 错误提示已由 axios 拦截器统一处理
      }
    },

    async handleSubmit(params) {
      try {
        if (this.editId) {
          await this.$http.updateNoteLabDeviceConfig(this.editId, params);
          this.$message({
            type: "success",
            message: this.$t("alertMsg.editSuccess"),
          });
        } else {
          await this.$http.createNoteLabDeviceConfig(params);
          this.$message({
            type: "success",
            message: this.$t("alertMsg.addSuccess"),
          });
        }
        this.dialogVisible = false;
        this.getConfigList();
      } catch {
        // 错误提示已由 axios 拦截器统一处理
      }
    },

    pageNum(val) {
      this.paramsList.page = val;
      this.getConfigList();
    },

    pageSizeChange(size) {
      this.paramsList.pageSize = size;
      this.paramsList.page = 1;
      this.getConfigList();
    },

    handleShowOptLogs(id) {
      this.$refs.optRecordDialog.open(id);
    },

    fetchOptLogsApi(id, params) {
      return this.$http.getNoteLabDeviceConfigOptLogs(id, params);
    },
  },

  async mounted() {
    await this.getRegionOptions();
    this.getConfigList();
  },
};
</script>

<style lang="scss" scoped>
.note-lab-device-config-page {
  height: 100%;
  display: flex;
  flex-direction: column;

  .global-header-wrap {
    padding: 10px 44px;
  }

  .user-header-left {
    display: flex;
    align-items: flex-end;
    flex-wrap: wrap;
    gap: 12px;
    width: calc(100% - 120px);
    float: left;
  }

  .right-part {
    float: right;
    padding-top: 20px;
  }

  .left-part {
    display: flex;
    flex-direction: column;

    > span {
      margin-bottom: 6px;
      font-size: 14px;
    }

    .listSearch .el-input {
      width: 180px;
    }
  }

  .search-btn {
    margin-top: 0;
    align-self: flex-end;
  }

  .user-table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
</style>
